import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'as-icon',
  templateUrl: './icons.component.html',
  styleUrls: ['./icons.component.scss']
})
export class IconsComponent implements OnInit {
  @Input() type: string = '';
  @Input() display: string = '';

  constructor() { }

  ngOnInit() {

  }

}
